import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { formatDateTime } from '../../utils/formatters';

export default function AuditLogs() {
  const [logs, setLogs] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => { api.get(`/audit-logs?page=${page}&limit=50`).then(res => setLogs(res.data.data.logs)); }, [page]);

  return (
    <div className="card">
      <h3 className="mb-2">Audit Trail</h3>
      <div className="table-container">
        <table>
          <thead><tr><th>Timestamp</th><th>User</th><th>Action</th><th>Module</th><th>Description</th><th>IP</th></tr></thead>
          <tbody>
            {logs.map(l => (
              <tr key={l._id}>
                <td className="text-xs">{formatDateTime(l.createdAt)}</td>
                <td>{l.userName}</td>
                <td><span className="badge badge-info">{l.action}</span></td>
                <td>{l.module}</td>
                <td style={{maxWidth:'300px'}} className="text-sm">{l.description}</td>
                <td className="text-xs text-muted">{l.ipAddress}</td>
              </tr>
            ))}
                      </tbody>
        </table>
      </div>
      <div className="flex justify-center mt-1">
        <button className="btn btn-sm btn-outline" disabled={page === 1} onClick={() => setPage(p => p - 1)}>Previous</button>
        <span className="p-1 text-sm">Page {page}</span>
        <button className="btn btn-sm btn-outline" onClick={() => setPage(p => p + 1)}>Next</button>
      </div>
    </div>
  );
}